import React from "react";
import ProjectCard from "./projectCard";
import ProjectSnapCarousel from "./projectSnapCarousel";
import "../style/projectView.css";
import Footer from "./footer";

const Project = React.forwardRef(function Projects(
  {
    title = "My Projects",
    projectData = [],
    expanded = [],
    toggleDescription = () => {},
  },
  ref,
) {
  return (
    <section className="project-view" ref={ref}>
      <div className="coding">
        <h1 className="coding-text">{title}</h1>
      </div>

      <ProjectSnapCarousel
        items={projectData}
        ariaLabel="Technical projects"
        footer={<Footer />}
        showBackToTop
        renderItem={(project, index) => (
          <ProjectCard
            image={project.image}
            title={project.title}
            languages={project.languages}
            description={project.description}
            link={project.link}
            layout={index % 2 === 0 ? "image-left" : "image-right"}
            isExpanded={!!expanded[index]}
            onToggle={() => toggleDescription(index)}
          />
        )}
      />
    </section>
  );
});

export default Project;
